/* Chez Smash — compléments v6 : statut ouvert + délai, vérification du code postal, bulle d'aide */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfgEl = $('#cs-config');
  const cfg = cfgEl ? cfgEl.dataset : {};
  const eur = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format((c || 0) / 100);

  /* Statut « ouvert » avec délai estimé (uniquement si un délai est renseigné) */
  const status = $('#cs-status');
  const eta = (cfg.eta || '').trim();
  if (status && window.CSOpen === true && status.hidden && eta) {
    status.hidden = false;
    status.classList.add('is-open');
    status.textContent = `Ouvert · Livraison estimée : ${eta}`;
  }
  $$('[data-cs-eta]').forEach((el) => { if (eta) { el.textContent = eta; el.closest('[data-cs-eta-wrap]')?.removeAttribute('hidden'); } });

  /* Vérification du code postal via le service de commande (même règles que la page de commande) */
  const endpoint = (cfg.endpoint || '').replace(/\/+$/, '');
  async function quote(zip, subtotal) {
    const r = await fetch(`${endpoint}/quote?zip=${encodeURIComponent(zip)}&subtotal=${subtotal || 0}`, { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('quote ' + r.status);
    return r.json();
  }
  $$('[data-cs-zone]').forEach((box) => {
    const form = $('form', box), input = $('input', box), btn = $('button', box), out = $('[data-cs-zone-out]', box);
    const show = (cls, html) => { out.hidden = false; out.className = 'cs-zone__out ' + cls; out.innerHTML = html; };
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const zip = input.value.replace(/\D/g, '').slice(0, 5);
      input.value = zip;
      if (zip.length !== 5) { show('is-ko', 'Entrez un code postal à 5 chiffres.'); input.focus(); return; }
      if (!endpoint) { show('is-info', 'La vérification n’est pas disponible pour le moment.'); return; }
      btn.disabled = true;
      try {
        let q = await quote(zip, 0);
        if (!q.ok && q.reason === 'minimum' && q.min_cents) q = { ...(await quote(zip, q.min_cents)), min_cents: q.min_cents };
        if (!q.ok) { show('is-ko', esc(q.message || 'Désolé, nous ne livrons pas encore ce code postal.')); return; }
        const parts = [`<strong>✓ Bonne nouvelle, nous livrons au ${esc(zip)}</strong> (${esc(q.zone)}).`];
        if (q.min_cents) parts.push(`Minimum de commande : <strong>${eur(q.min_cents)}</strong>.`);
        if (q.fee_cents) parts.push(`Frais de livraison : <strong>${eur(q.fee_cents)}</strong>${q.free_from_cents ? `, offerts dès ${eur(q.free_from_cents)}` : ''}.`);
        else parts.push('Livraison <strong>offerte</strong>.');
        if (eta) parts.push(`Délai estimé : <strong>${esc(eta)}</strong>.`);
        if (q.open === false) parts.push('<br>Nous sommes fermés en ce moment : les commandes ouvrent ' + esc(($('[data-cs-hours-short]') || {}).textContent || 'aux heures d’ouverture') + '.');
        show('is-ok', parts.join(' '));
      } catch (err) {
        show('is-info', 'Impossible de vérifier pour le moment. Votre code postal sera de toute façon vérifié avant de valider la commande.');
      } finally { btn.disabled = false; }
    });
  });

  /* Liens WhatsApp de la page Contact (numéro réglé dans l'en-tête du thème) */
  const waHref = (cfg.waHref || '').trim();
  if (waHref) $$('[data-cs-wa]').forEach((a) => { a.href = waHref; a.hidden = false; });

  /* Bulle d'aide : version compacte après défilement pour ne pas gêner la lecture */
  const help = $('.cs-help');
  if (help) {
    let t;
    const compact = () => help.classList.toggle('is-compact', window.scrollY > 240);
    window.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(compact, 60); }, { passive: true });
    compact();
  }
})();
